<template>
	<div>
		<button class="better-mobile-btn" v-on:click="startGiving" :class="hasGiven ? 'grey-background' : ''">
			{{ hasGiven ? "Given" : "Give Item" }}
		</button>

		<div v-if="isGiving" class="fullscreen-overlay">
			<h2 class="overlay-header">{{ user_name }}</h2>

			<div class="overlay-body">
				<h5 class="p-05">{{ credential_title }}</h5>

				<div>
					<div class="p-05">
						<p>
							{{ "Press the button to below to confirm that you have given "}}
							<strong>{{ user_name }}</strong>
							{{" a "}}
							<strong>{{ credential_title }}</strong>
						</p>

						<button
							class="better-mobile-btn"
							v-on:click="complete">
							{{ "Given Item on Patron" }}
						</button>
					</div>
				</div>

				<div class="p-1">
					<button class="better-mobile-btn red" v-on:click="back">Back</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DisburseUnscannedButton',
	components: {
	},
	props: {
		user_name: {
			type: String,
			required: true
		},
		credential_title: {
			type: String,
			required: true
		},
		initial_value: {
			type: String,
			default: ""
		},
	},
	data() {
		return {
			hasGiven: !!this.initial_value,
			isGiving: false,
		}
	},
	methods: {
		startGiving() {
			this.isGiving = true
			this.hasGiven = false
		},
		complete() {
			this.isGiving = false
			this.hasGiven = true
			this.$emit('given');
		},
		resetState() {
			this.hasGiven = false
		},
		back() {
			this.isGiving = false
			this.resetState()
		},
		async startScanning() {
			this.startGiving()
		},
	},
}
</script>

<style scoped>
.grey-background {
	background: #666 !important;
}
</style>